import { Card, CardContent, CardMedia } from '@material-ui/core';
import React from 'react';
import makeAsyncScriptLoader from 'react-async-script';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getMessage } from '../../reducers/i18n';
import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';
import Heading from '../heading/Heading';
import CartWrapper from '../styles/AddToCartWrapper';

import { media } from '../styles/breakpoints';
import Form from './CartForm';
import PriceDisplay from './PriceDisplayWithHeading';

const URL = '//cdn.foxycart.com/checkout.stoff.love/loader.js';

defineMessages({
    starterSetAdvanced: {
        id: 'CART_LABEL_STARTERSET_ADVANCED',
        defaultMessage: 'Musterpaket von allen Stoffqualitäten',
    },
    starterSetProfessional: {
        id: 'CART_LABEL_STARTERSET_PROFESSIONAL',
        defaultMessage: 'Großes Stoffmuster & Farbkarte',
    },
});

const Wrapper = styled.div`
  margin: ${props => props.theme.space[7]} 0;
  padding: 0 ${props => props.theme.space[8]} 0 ${props => props.theme.space[4]};
  position: relative;

  & p {
    margin-bottom: ${props => props.theme.space[0]};
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-evenly;
  margin-top: ${props => props.theme.space[8]};

  ${media.tweak900up`
        flex-direction: column;
        justify-content: flex-end;
    `};
`;

const StyledCard = styled(Card)`
  max-width: 49%;
  padding: 0;

  ${media.tweak900up`
        max-width: 100%;
        margin-bottom: ${props => props.theme.space[10]};
    `};
`;

const StyledMedia = styled(CardMedia)`
  height: ${props => props.theme.space[18]};
`;

const StyledCardContent = styled(CardContent)`
  padding: ${props => props.theme.space[6]};

  &:last-child {
    padding-bottom: 0;
  }

  & .cart-form-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${media.tweak900up`
          flex-direction: row;
          justify-content: space-around;
          align-items: flex-start;
      `}

    ${media.tweak500up`
        flex-direction: column;
        align-items: stretch;
        justify-content: space-around;
    `};
  }

  & .cart-form-flex-item {
    width: 100%;
    max-width: 60ch;
    margin: 0 auto;
    display: block;
    line-height: 1;
  }
`;

const StarterSetCartForms = props => (
    <Wrapper>
        <FlexWrapper>
            <StyledCard>
                <StyledMedia
                    image={'https://d2k02hhj0n6fcf.cloudfront.net/images/fortgeschrittene-stoffmuster-howto-kostenlos-v1.jpg'}
                    title='3 Farbmuster mit jeweils 35 Farben mit Einführungskurs.'
                />
                <StyledCardContent>
                    <div className='cart-form-flex'>
                        <div className='cart-form-flex-item'>
                            <Form
                                heading={props.starterSetAdvanced}
                                buttonLabel={props.cartButtonLabel}
                                foxyLabel={props.starterSetAdvanced}
                                amount={5.55}
                                foxyCode={'starterset-advanced'}
                            />
                        </div>
                    </div>
                </StyledCardContent>
            </StyledCard>
            <StyledCard>
                <StyledMedia
                    image={'https://d2k02hhj0n6fcf.cloudfront.net/images/profi-gratis-kurs-farbkarteXXL-v1.jpg'}
                    title='Grosse XXXL Farbkarte mit 448 Farben und HowTo.'
                />
                <StyledCardContent>
                    <div className='cart-form-flex'>
                        <div className='cart-form-flex-item'>
                            <Form
                                heading={props.starterSetProfessional}
                                buttonLabel={props.cartButtonLabel}
                                foxyLabel={props.starterSetProfessional}
                                amount={14.98}
                                foxyCode={'starterset-professional'}
                            />
                        </div>
                    </div>
                </StyledCardContent>
            </StyledCard>
        </FlexWrapper>
    </Wrapper>
);

const mapStateToProps = state => (
    {
        cartButtonLabel: getMessage(state, 'CART_BUTTON_LABEL'),
        starterSetFree: getMessage(state, 'CART_LABEL_STARTERSET_FREE'),
        starterSetAdvanced: getMessage(state, 'CART_LABEL_STARTERSET_ADVANCED'),
        starterSetProfessional: getMessage(state,
            'CART_LABEL_STARTERSET_PROFESSIONAL',
        ),
    }
);

const connectedStarterSetCartForm = connect(mapStateToProps)(
    StarterSetCartForms);

const ConnectedStarterSetCartFormLoader = makeAsyncScriptLoader(
    connectedStarterSetCartForm, URL);

export default ConnectedStarterSetCartFormLoader;



// WEBPACK FOOTER //
// ./src/components/cartforms/StarterSetCartForm.js